import {
    BaseService
} from "./BaseService";
import {
    SnackBarModule
} from "../modules/SnackBarModule";

export const AtosBoletimService = {
    async pesquisar(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ato/pesquisar`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return await response.message;
    },

    async editarAto(postData, idAto) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ato/editar/${idAto}`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.message;
    },

    async editarLegislacao(postData, idAto) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ato/legislacao/${idAto}?_method=PUT`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }

        SnackBarModule('Legislação editada com sucesso', "success");
        return true
    },

    async pegarLegislacao(postData) {
        const response = await BaseService.fetchResponseFromAPIGet(
            `ato/legislacao`,
            postData);
        if (response.error) {
            SnackBarModule(response.content, "error");
            return false;
        }
        return response.content;
    },

    async downloadAto(idAto, postData = null) {
        const response = await BaseService.downloadItemPost(
            `ato/${idAto}`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        SnackBarModule("Baixado com sucesso", "success");
        return true;
    },

    async deletarAto(id) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ato/${id}/delete`,
        );
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        SnackBarModule("Excluído com sucesso", "success");
        return true;
    },

    async listarTipos() {
        const response = await BaseService.fetchResponseFromAPIGet(`ato/tipos`);
        if (response.error) {
            SnackBarModule("Houve um erro ao listar as unidades", "error");
        }
        return response.content;
    },

    async listarAtos() {
        const response = await BaseService.fetchResponseFromAPIGet(`ato/atos`);
        if (response.error) {
            SnackBarModule("Houve um erro ao listar as unidades", "error");
        }
        return response.content;
    },
}